const sideProjects = [
{
      slug:"representacaoauntentica",
      name: "Representação Auntêntica",
      mainImg: "/img/representacao/red.jpg",
      link: "https://www.behance.net/gallery/68978301/Representacao-Auntentica",
      role: "For this university i was part of the concept creation, 3d printing process, assembly process and final compoosition. ",
      roleTags: "Design | 3D Print | Assembly | 3D Modelling",
      thumb:"/img/representacao/thumb.png",
      desc:
        "Representação Autêntica its a design bachelor work with partnership with Cine Teatro de Santo António.It represents a technological world and a teather world as one is the continuation of the other and at the same time diferent worlds.",
      imgs:[
        "/img/representacao/0.mov",
        "/img/representacao/01.jpg",
        "/img/representacao/03.mov",
        "/img/representacao/1.jpg",
        "/img/representacao/2.jpg",
        "/img/representacao/3.jpg",
        "/img/representacao/4.jpg",
        "/img/representacao/5.jpg",
        "/img/representacao/6.jpg",
        "/img/representacao/movie.MOV",
        ],
    }, {
      slug:"bambalbu",
      name: "Bambalbu",
      mainImg: "/img/bambalbu/4.jpg",
      link: "https://www.behance.net/gallery/67280193/BAMBALBU-TOY-_-Design-Product",
      role: "Part of all the process with my class colleague from ideation, sketching, finding the materials, constructing prototypes, develop the graphics, packaging and final product.",
      roleTags: "Ideation | Product Design | Build ",
      thumb:"/img/bambalbu/thumb.png",
      desc:
        "Bambalbu is a product designed and created for a university project where the theme was to create a toy with features from the childhood and Madeira Island caractheristic elements. Cars were a part of growing up and as Madeira Island is known for wood it was the selected material. The project was fuuly created using organic and natural elements.",
      imgs:[
        "/img/bambalbu/1.png",
        "/img/bambalbu/2.jpg",
        "/img/bambalbu/3.jpg",
        "/img/bambalbu/5.jpg",
        "/img/bambalbu/6.jpg",
        "/img/bambalbu/7.png",
        "/img/bambalbu/8.jpg",
        "/img/bambalbu/9.jpg",
        "/img/bambalbu/10.jpg",
        "/img/bambalbu/video.mp4",
        ],
    } 
]

export default sideProjects;